// Sales → Sales Order Board (Sales Order Board D-8): how often the board reloads itself while its
// browser tab is visible and no modal is open. One place to raise it if the refresh proves costly.
export const salesOrderBoardRefreshMilliseconds = 60000;
